import React from "react";
import { Link } from "react-router-dom";
import clsx from "clsx";

import IcnChevronRight from "@assets/icons/chevron-right-sharp.svg";
import ImgCtaDecTL from "@assets/images/cta-decoration-tl.png";
import ImgCtaDecTR from "@assets/images/cta-decoration-tr.png";
import ImgCtaDecBL from "@assets/images/cta-decoration-bl.png";
import ImgCtaDecBR from "@assets/images/cta-decoration-br.png";

import { IconComponent } from "../icon";
import styles from "./cta-card.module.scss";

export type CtaCardProps = {
  title?: string;
  subtitle?: string;
  href: string;
  className?: string;
};

const CtaCard = ({ title, subtitle, href, className }: CtaCardProps) => {
  return (
    <Link className={clsx(styles.root, className)} to={href}>
      <div className={styles.bg}>
        <img className={styles.tl} src={ImgCtaDecTL} />
        <img className={styles.tr} src={ImgCtaDecTR} />
        <img className={styles.bl} src={ImgCtaDecBL} />
        <img className={styles.br} src={ImgCtaDecBR} />
      </div>
      <div className={styles.content}>
        {title && <h4>{title}</h4>}
        {subtitle && (
          <div className={styles.link}>
            <IconComponent icon={IcnChevronRight} size="12px" />
            <span>{subtitle}</span>
          </div>
        )}
      </div>
    </Link>
  );
};

export { CtaCard };
